
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { useLocation, useNavigate } from "react-router-dom";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { Divider } from "@mui/material";
import { FaFileInvoice } from "react-icons/fa";
import logo from "../../../assets/CRM-logo.png";
import Icon from '@mui/icons-material';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { FaClipboardList, FaTasks } from "react-icons/fa";
import { FaFileInvoiceDollar, FaShoppingCart, FaStoreAlt } from "react-icons/fa";
import { LayoutDashboard } from "lucide-react";
import { useCrm } from "../../../context/CrmContext";
import { imageBaseUrl } from "../../../utils/utils";

const CrmSideBarUI = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { user } = useCrm()

    const sideBarData = [
        // {
        //     id: "dashboard",
        //     icon: <LayoutDashboard />,
        //     label: "Dashboard",
        //     url: "/crm/dashboard",
        // },
        {
            id: "manageUsers",
            icon: <CreditCardIcon />,
            label: "Create Invoice",
            url: "/crm/create-invoice",
        },
        // {
        //     id: "allApplicants",
        //     icon: <PeopleAltIcon />,
        //     label: "Manage User",
        //     url: "/crm/users",
        // },
        {
            id: "manageInvoice",
            icon: <FaFileInvoice />,
            label: "Manage Invoice",
            url: "/crm/manage-invoice",
        },
        {
            id: "manageProduct",
            icon: <FaClipboardList />,
            label: "Manage Product",
            url: "/crm/manage-product",
        },
        {
            id: "addProduct",
            icon: <FaTasks />,
            label: "Add Product",
            url: "/crm/add-product",
        },
        // {
        //     id: "manageCustomer",
        //     icon: <GroupAddIcon />,
        //     label: "Manage Customer",
        //     url: "/crm/manage-customer",
        // },
        // {
        //     id: "purchaseOrder",
        //     icon: <FaClipboardList />,
        //     label: "Purchase Order",
        //     url: "/crm/purchase-order",
        // },
        // {
        //     id: "manageItem",
        //     icon: <FaTasks />,
        //     label: "Manage Purchase Item",
        //     url: "/crm/manage-purchase-item",
        // },
        // {
        //     id: "managePurchaseOrder",
        //     icon: <FaFileInvoiceDollar />,
        //     label: "Manage Purchase Order",
        //     url: "/crm/manage-purchase-order",
        // },
        // {
        //     id: "manageDirectSales",
        //     icon: <FaShoppingCart />,
        //     label: "Manage Direct Sales",
        //     url: "/crm/manage-diract-sales",
        // },
        // {
        //     id: "manageIndirectSales",
        //     icon: <FaStoreAlt />,
        //     label: "Manage Indirect Sales",
        //     url: "/crm/manage-indiract-sales",
        // },
    ];

    const handleNavigation = (url) => {
        navigate(url);
    };

    return (
        <Box
            sx={{
                width: 265,
                flexShrink: 0,
                height: "100vh",
                border: "none",
            }}
            className="bg-[#f4f5f7f1]"
            // className="bg-gradient-to-b from-[#272264] to-[#2f2880]"
            square
        >
            <Box sx={{ overflowY: "auto", height: "100%" }}>
                <div className="flex flex-col justify-center pb-1 pl-8">
                    {user?.profile_image ? (
                        <img
                            src={imageBaseUrl + "images/" + user.profile_image}
                            className="w-[80px] h-[80px] object-cover pt-4"
                            alt="Logo"
                        />
                    ) : (
                        <div className="text-white text-[30px] uppercase font-bold">
                            {user?.companyName}
                        </div>
                    )}
                </div>

                <List>
                    {sideBarData.map((item) => (
                        <ListItem key={item.id}>
                            <ListItemButton
                                onClick={() => handleNavigation(item.url)}
                                sx={{
                                    backgroundColor:
                                        location.pathname === item.url
                                            ? "#23806D"
                                            : "transparent",
                                    borderRadius: "4px",
                                    "&:hover": {
                                        backgroundColor: "#4DA896",
                                    },
                                }}
                            >
                                <item.icon.type
                                    className={`${location.pathname === item.url
                                        ? "text-white"
                                        : "text-black"
                                        }`}
                                />
                                <ListItemText
                                    primary={item.label}
                                    className={`${location.pathname === item.url
                                        ? "text-white"
                                        : "text-black"
                                        } pl-2`}
                                />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Box>
    );
};

export default CrmSideBarUI;
